import React from 'react';
import PropTypes from 'prop-types';

import { Card, Row, Col } from 'react-bootstrap';

function AvatarBox(props) {
    /* eslint react/prop-types: 0 */
    const {
        name,
        surname,
        roleName,
        mail = null,
        img = null // eg: 'data:image/png;base64,xxx' | href
    } = props;

    return (
        <Row className="content avatar-box" data-testid={'test-avatar-box'}>
            <Col className="left">
                <svg className="circle-preview" style={{ borderRadius: '50%' }}>
                    {img ? (
                        <image
                            href={`data:image/png;base64, ${props.img}`}
                            width={'86'}
                            height={'86'}
                            preserveAspectRatio="none"
                        />
                    ) : (
                        <>
                            <circle />
                            <text
                                x="50%"
                                y={
                                    navigator.userAgent
                                        .toString()
                                        .includes('Firefox')
                                        ? '65%'
                                        : '52%'
                                }
                            >{`${name[0]}${surname[0]}`}</text>
                        </>
                    )}
                </svg>
            </Col>
            <Col className="right">
                <div className="titles">
                    <Card.Subtitle className="mb-1">{name}</Card.Subtitle>
                    <Card.Title>{surname}</Card.Title>
                </div>
                <div className="text">
                    <p className="role-name">{roleName}</p>
                    {mail && <p className="mail">{mail}</p>}
                </div>
            </Col>
        </Row>
    );
}

AvatarBox.propTypes = {
    name: PropTypes.string.isRequired,
    surname: PropTypes.string.isRequired,
    roleName: PropTypes.string.isRequired,
    mail: PropTypes.string,
    img: PropTypes.string
};

export default AvatarBox;
